import { GraphDataViewModel } from "@features/graph/graphViewModel"
import { GraphNodeData, GraphNodeEdgeData } from "@store/services/converter/types"
import logger from "@utils/logger"

// TODO KK: remove this file as it cuts off reactivity (manually manipulating url params / browser history) - use react-router instead
export const graphUrlAddNode = (nodeLabel: string, replace = false) => {
  try {
    const url = new URL(window.location.href)
    if (replace) {
      url.searchParams.set("nodeLabel", nodeLabel)
    } else {
      const labels = new Set(url.searchParams.getAll("nodeLabel"))
      if (!labels.has(nodeLabel)) {
        url.searchParams.append("nodeLabel", nodeLabel)
      }
    }
    window.history.pushState({ path: url.href }, "", url.href)
  } catch (e) {
    logger.error("Error adding nodeLabel to url", e, nodeLabel)
  }
}

export const graphUrlRemoveNode = (nodeId: string) => {
  try {
    const nodeLabel = GraphDataViewModel.data?.labelMap[nodeId]
    if (nodeLabel) {
      const url = new URL(window.location.href)
      url.searchParams.delete("nodeLabel", nodeLabel)
      window.history.pushState({ path: url.href }, "", url.href)
    }
  } catch (e) {
    logger.info("Error removing nodeLabel from url", e, nodeId)
  }
}

export const graphUrlClearNodes = () => {
  const url = new URL(window.location.href)
  if (url.searchParams.has("nodeLabel")) {
    url.searchParams.delete("nodeLabel")
    window.history.pushState({ path: url.href }, "", url.href)
  }
}

export const graphUrlGetFirstNodeLabel = (data: GraphNodeEdgeData): GraphNodeData | undefined => {
  if (window.location.hash.split("#").length === 1) return
  const hash = window.location.hash
  let nodeLabel = hash && hash.split("#")[1]
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  nodeLabel = decodeURIComponent(nodeLabel)
  const nodeFilter = Object.entries(data.labelMap).filter(([_, value]) => value === nodeLabel)
  if (!nodeFilter) return
  // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
  return data.nodeMap[nodeFilter[0][0]]
}

export const hasDashboardParamUrl = () => {
  const url = new URL(window.location.href)
  return url.searchParams.has("dashboard")
}

export const getDashboardParamUrl = () => {
  const url = new URL(window.location.href)
  return url.searchParams.get("dashboard")
}

export const setDashboardParamUrl = (dashboard: string) => {
  const url = new URL(window.location.href)
  url.searchParams.set("dashboard", dashboard)
  window.history.pushState({ path: url.href }, "", url.href)
}

export const delDashboardParamUrl = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete("dashboard")
  window.history.pushState({ path: url.href }, "", url.href)
}
